import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import HavenBrand from "./HavenBrand";

const links = [
  { to: "/", label: "Home" },
  { to: "/diagnose", label: "Diagnose" },
  { to: "/snapshot", label: "Snapshot" },
  { to: "/join", label: "Founding" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        background: scrolled ? "rgba(251,248,242,0.85)" : "rgba(244,237,223,0.4)",
        borderBottom: scrolled ? "1px solid var(--border-soft)" : "1px solid transparent",
        transition: "background 240ms ease, border-color 240ms ease",
      }}
    >
      <div
        className="haven-page-shell-wide"
        style={{ paddingTop: 14, paddingBottom: 14, display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        <HavenBrand />
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                style={{
                  fontSize: 13,
                  color: active ? "var(--ink)" : "var(--ink-soft)",
                  fontWeight: 500,
                  letterSpacing: "0.02em",
                  textDecoration: "none",
                  position: "relative",
                  paddingBottom: 2,
                  borderBottom: active ? "1px solid var(--gold)" : "1px solid transparent",
                  transition: "color 180ms ease, border-color 180ms ease",
                }}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <Link to="/join" data-testid="nav-cta-join" className="haven-btn haven-btn-gold">
          Lock founding rate
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </header>
  );
};

export default Nav;
